import { useEffect, useState } from 'react'
import { refreshSession, refreshUser } from '../../redux/slices/sessionSlice'
import { useSelector, useDispatch } from 'react-redux'
import { DefaultState } from '../../types'
import { useNavigate } from 'react-router-dom'
const Auth = () => {
  const { expiresAt, accessToken } = useSelector(
    (state: DefaultState) => state.session.data
  )
  const [currentTimeout, setCurrentTimeout] = useState<null | NodeJS.Timeout>(null)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    if(currentTimeout) {
      clearTimeout(currentTimeout)
    }

    if(accessToken) {
      const timeLeft = ((expiresAt || 0) * 1000) - Date.now()
      setCurrentTimeout(setTimeout(() => {
        dispatch(refreshSession())
      }, timeLeft))
    } else {
      setCurrentTimeout(null)
    }
  }, [accessToken])

  useEffect(() => {
    if(accessToken && !window.location.pathname.includes('login')) {
      dispatch(refreshUser())
    } else if(window.location.pathname !== '/ui2/login'){
      navigate('/ui2/login')
    }
  }, [])

  return (<>
    {accessToken && <CheckUser />}
  </>)
}

const CheckUser = () => {
  const [currentTimeout, setCurrentTimeout] = useState<null | NodeJS.Timeout>(null)

  useEffect(() => {
    console.log('------- initially - need to call check user with dispatch on server ----')

    if(currentTimeout) {
      clearTimeout(currentTimeout)
    }

    setCurrentTimeout(setInterval(() => {
      console.log('------- need to call check user with dispatch on server ----')
    }, 10000))

    return () => {
      console.log('------- stopping check user ---------')
      if(currentTimeout)
        clearTimeout(currentTimeout)
    }
    
  },[])

  return <></>

}

export default Auth
